// extracted by mini-css-extract-plugin
module.exports = {"buffering-loader-container":"buffering-loader-container-P7S0m","buffering-loader":"buffering-loader-fMSpb"};